import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// --- ES ---
import commonEs from '../locales/es/common.json';
import billingEs from '../locales/es/billing.json';
import botsEs from '../locales/es/bots.json';
import channelsEs from '../locales/es/channels.json';
import chatsEs from '../locales/es/chats.json';
import campaignsEs from '../locales/es/campaigns.json';
import addonsEs from '../locales/es/addons.json';
import dashboardEs from '../locales/es/dashboard.json';
import organizationEs from '../locales/es/organization.json';
import errorsEs from '../locales/es/errors.json';
import validationEs from '../locales/es/validation.json';
import statisticsEs from '../locales/es/statistics.json';
import adsStudioEs from '../locales/es/adsStudio.json';

// --- EN ---
import commonEn from '../locales/en/common.json';
import billingEn from '../locales/en/billing.json';
import botsEn from '../locales/en/bots.json';
import channelsEn from '../locales/en/channels.json';
import chatsEn from '../locales/en/chats.json';
import campaignsEn from '../locales/en/campaigns.json';
import addonsEn from '../locales/en/addons.json';
import dashboardEn from '../locales/en/dashboard.json';
import organizationEn from '../locales/en/organization.json';
import errorsEn from '../locales/en/errors.json';
import validationEn from '../locales/en/validation.json';
import statisticsEn from '../locales/en/statistics.json';
import adsStudioEn from '../locales/en/adsStudio.json';

// --- PT ---
import commonPt from '../locales/pt/common.json';
import billingPt from '../locales/pt/billing.json';
import botsPt from '../locales/pt/bots.json';
import channelsPt from '../locales/pt/channels.json';
import chatsPt from '../locales/pt/chats.json';
import campaignsPt from '../locales/pt/campaigns.json';
import addonsPt from '../locales/pt/addons.json';
import dashboardPt from '../locales/pt/dashboard.json';
import organizationPt from '../locales/pt/organization.json';
import errorsPt from '../locales/pt/errors.json';
import validationPt from '../locales/pt/validation.json';
import statisticsPt from '../locales/pt/statistics.json';
import adsStudioPt from '../locales/pt/adsStudio.json';

const savedLanguage = localStorage.getItem('i18nextLng') || 'es';

i18n.use(initReactI18next).init({
  resources: {
    es: {
      common: commonEs,
      billing: billingEs,
      bots: botsEs,
      channels: channelsEs,
      chats: chatsEs,
      campaigns: campaignsEs,
      addons: addonsEs,
      dashboard: dashboardEs,
      organization: organizationEs,
      errors: errorsEs,
      validation: validationEs,
      statistics: statisticsEs,
      adsStudio: adsStudioEs,
    },
    en: {
      common: commonEn,
      billing: billingEn,
      bots: botsEn,
      channels: channelsEn,
      chats: chatsEn,
      campaigns: campaignsEn,
      addons: addonsEn,
      dashboard: dashboardEn,
      organization: organizationEn,
      errors: errorsEn,
      validation: validationEn,
      statistics: statisticsEn,
      adsStudio: adsStudioEn,
    },
    pt: {
      common: commonPt,
      billing: billingPt,
      bots: botsPt,
      channels: channelsPt,
      chats: chatsPt,
      campaigns: campaignsPt,
      addons: addonsPt,
      dashboard: dashboardPt,
      organization: organizationPt,
      errors: errorsPt,
      validation: validationPt,
      statistics: statisticsPt,
      adsStudio: adsStudioPt,
    },
  },
  lng: savedLanguage,
  fallbackLng: 'es',
  supportedLngs: ['es', 'en', 'pt'],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
